/**
 * 地図検索: PC のみサイドバー初期非表示＋地図クリックで開閉。SP は従来どおり常時表示でトグルなし。
 */
export function initSearchMapSidebar() {
	const root = document.querySelector('[data-search-map]');
	if (!root) return;

	const main = root.querySelector('.searchMap__main');
	const map = root.querySelector('.searchMap__map');
	const sidebar = root.querySelector('.searchMap__sidebar');
	if (!(main instanceof HTMLElement) || !(map instanceof HTMLElement) || !(sidebar instanceof HTMLElement)) {
		return;
	}

	const mqPc = window.matchMedia('(min-width: 768px)');

	const setOpen = (open) => {
		main.classList.toggle('is-sidebar-open', open);
		sidebar.setAttribute('aria-hidden', open ? 'false' : 'true');
		if (open) {
			sidebar.removeAttribute('inert');
		} else {
			sidebar.setAttribute('inert', '');
		}
	};

	const syncToBreakpoint = () => {
		if (mqPc.matches) {
			setOpen(main.classList.contains('is-sidebar-open'));
		} else {
			main.classList.remove('is-sidebar-open');
			sidebar.setAttribute('aria-hidden', 'false');
			sidebar.removeAttribute('inert');
		}
	};

	syncToBreakpoint();
	mqPc.addEventListener('change', syncToBreakpoint);

	map.addEventListener('click', () => {
		if (!mqPc.matches) return;
		setOpen(!main.classList.contains('is-sidebar-open'));
	});
}
